import { render, staticRenderFns } from "./publishRuleConfig.vue?vue&type=template&id=425f5c15&scoped=true&"
import script from "./publishRuleConfig.vue?vue&type=script&lang=js&"
export * from "./publishRuleConfig.vue?vue&type=script&lang=js&"
import style0 from "./publishRuleConfig.vue?vue&type=style&index=0&id=425f5c15&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f5c15",
  null
  
)

export default component.exports